import { Link } from "react-router-dom";
import { useReveal } from "@/hooks/useReveal";
import { formatPrice } from "./format";

export default function UFJPieces({ pieces }) {
  const head = useReveal();
  if (!pieces?.length) return null;

  return (
    <section id="ufj-pieces" data-testid="ufj-pieces" className="relative bg-black py-28 md:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div ref={head} className="pd-reveal flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="eyebrow">Selected Pieces</p>
            <h2 className="mt-5 font-serif-display text-4xl md:text-5xl text-white tracking-[0.06em]">
              Presented in <span className="italic font-serif-body text-gold-gradient">confidence.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-sm leading-relaxed">
            Each piece is introduced individually. Official names, certificates and specifications are
            published only once verified by the atelier.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--pd-border)] border border-[var(--pd-border)]">
          {pieces.map((p, i) => <PieceCard key={p.slug} piece={p} index={i} />)}
        </div>
      </div>
    </section>
  );
}

function PieceCard({ piece, index }) {
  const r = useReveal();
  return (
    <Link
      ref={r}
      to={`/ultra-fine-jewelry/${piece.slug}`}
      data-testid={`ufj-piece-card-${piece.slug}`}
      style={{ transitionDelay: `${(index % 3) * 120}ms` }}
      className="pd-reveal group block bg-black"
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={piece.images[0]}
          alt={`${piece.name} — concept imagery`}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover brightness-[0.8] transition-transform duration-[2400ms] group-hover:scale-110"
        />
        <span className="absolute top-4 left-4 text-[0.5rem] uppercase tracking-[0.4em] text-white/60 bg-black/60 backdrop-blur px-2.5 py-1">
          Concept
        </span>
      </div>
      <div className="p-7 flex items-start justify-between gap-4">
        <div>
          <p className="eyebrow text-white/50">{piece.category_name}</p>
          <h3 className="mt-2 font-serif-display text-xl text-white tracking-[0.08em] group-hover:text-[var(--pd-gold)] transition-colors duration-500">
            {piece.official_name || piece.name}
          </h3>
          <p className="mt-1 text-white/40 text-[0.6rem] uppercase tracking-[0.36em]">{piece.reference}</p>
        </div>
        <span
          className="text-[0.6rem] uppercase tracking-[0.32em] text-[var(--pd-gold)] whitespace-nowrap pt-1"
          data-testid={`ufj-piece-card-${piece.slug}-price`}
        >
          {formatPrice(piece)}
        </span>
      </div>
    </Link>
  );
}
